module.exports = __webpack_public_path__ + "static/consulting-banner-img-tiny-1fefd6860da02a26936e1656aba0ed28.jpg";